export const dealStatusMachine = {
    name: 'deal',
    states: ['active', 'lost', 'cancelled'],
    labels: { active: 'Aktiv', lost: 'Verloren', cancelled: 'Storniert' },
    transitions: [
        {
            name: 'lose',
            label: 'Verloren',
            from: ['active'],
            to: 'lost',
            reasonRequired: true,
            fields: ['lostReasonId'],
            permission: { key: 'deals.change_stage', allowed: ['own', 'yes'] },
            ownership: 'owner_or_permission',
        },
        {
            name: 'reopen',
            label: 'Wieder öffnen',
            from: ['lost'],
            to: 'active',
            reasonRequired: true,
            permission: { key: 'settings.organization', allowed: ['yes'] },
        },
        {
            name: 'cancel',
            label: 'Storno',
            from: ['active'],
            to: 'cancelled',
            reasonRequired: true,
            nextStepRequired: true,
            permission: { key: 'deals.lose_after_notarized_cancel', allowed: ['yes'] },
        },
    ],
};
/** Order and conditions of the system stages of the property pipeline (§5.3, P-02). */
export const dealSystemStages = [
    { key: 'consultation', label: 'Beratung', conditions: [], fields: [] },
    {
        key: 'self_disclosure_done',
        label: 'SA ausgefüllt',
        conditions: ['Unterschriebene Selbstauskunft (aktuelle Version)'],
        fields: [],
    },
    {
        key: 'reserved',
        label: 'Reserviert',
        conditions: ['Aktive Reservierung an einer Einheit des Deals'],
        fields: [],
    },
    { key: 'financing', label: 'Finanzierung', conditions: [], fields: [] },
    {
        key: 'notary_appointment',
        label: 'Notartermin',
        conditions: ['Notartermin am Deal', 'Unterschriebene Finanzierung (Fina-Unterschrift)'],
        fields: [],
        warningReason: true,
    },
    { key: 'notarized', label: 'Beurkundet', conditions: [], fields: ['notarizedOn'] },
    { key: 'purchase_price_paid', label: 'KP-Zahlung', conditions: [], fields: ['purchasePriceReceivedOn'] },
];
export const dealSystemStageOrder = dealSystemStages.map((s) => s.key);
export function systemStageIndex(key) {
    return dealSystemStageOrder.indexOf(key);
}
//# sourceMappingURL=deal.js.map